import React, { Component } from "react";
import track from "../lib/tracking";
import MovieInput from "./MovieInput";
import CountryInput from "./CountryInput";
import LocationInput from "./LocationInput";
import SelectTabs from "./SelectTabs";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import _ from "lodash";
import moment from "moment";

import Button from "../elements/Button";
import NumberCircle from "../elements/NumberCircle";
import RangeInput from "../elements/RangeInput";
import "../styles/ReactDatepicker.css";

class ShowtimesSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      movie: "",
      movieSelected: null,
      movieResults: [],
      timeFrom: moment(),
      timeTo: moment().add(7, "day"),
      locationFilter: props.cinemaId !== 0 ? "cinema" : "location", //location, country, cinema
      countryCodes: [],
      country: "",
      countryResults: [],
      cinemaId: props.cinemaId,
      location: "",
      locationResults: [],
      locationSelected: null,
      distance: 10,
    };
  }

  getLocationFilterString = () => {
    switch (this.state.locationFilter) {
      case "location":
        const coordinates =
          this.state.locationSelected.geometry.location.lat +
          "," +
          this.state.locationSelected.geometry.location.lng;
        return "&location=" + coordinates + "&distance=" + this.state.distance;
      case "cinema":
        return "&cinema_id=" + this.state.cinemaId;
      case "country":
        return (
          "&countries=" + this.state.countryCodes.map(o => o.code).join(",")
        );
      default:
        return null;
    }
  };
  getLocationFilterName = () => {
    switch (this.state.locationFilter) {
      case "location":
        return this.state.locationSelected.formatted_address;
      case "cinema":
        return this.state.cinemaId;
      case "country":
        return this.state.countryCodes.map(o => o.name).join(",");
    }
  };
  update = () => {
    if (!this.state.movieSelected) {
      this.props.setStatus("error","Please choose a movie.");
      return;
    }

    if (
      !this.state.locationSelected &&
      this.state.countryCodes.length < 1 &&
      !this.state.cinemaId
    ) {
      this.props.setStatus("error","Please choose a location.");
      return;
    }

    if (
      !this.state.timeFrom ||
      !this.state.timeTo ||
      this.state.timeTo.isBefore(this.state.timeFrom)
    ) {
      this.props.setStatus("error","Please choose a valid date range.");
      return;
    }
    document.cookie = `status=used;path=/`;

    this.props.setStatus("loading","");
    const locationFilter = this.getLocationFilterString();
    const headers = new Headers();
    headers.append("x-api-key", "fYaO4I8DUGXi71Z139wYvkjlFrUPf9sM");
    track("submit_search", {
      option_search_main: "showtimes",
      movie_name: this.state.movieSelected.title,
      film_id: this.state.movieSelected.id,
      date_start: this.state.timeFrom.startOf("day").format("DD/MM/YYYY"),
      date_end: this.state.timeTo.endOf("day").format("DD/MM/YYYY"),
      option_location_filter: this.state.locationFilter,
      location_name: this.state.locationFilter === "location" ? this.state.locationSelected.formatted_address : (this.state.cinemaId || this.state.countryCodes.map(o => o.name)),
      distance: this.state.distance
    });
    fetch(
      "https://api.internationalshowtimes.com/v4/showtimes?lang=en&append=cinemas&cinema_fields=id,name,location.lat,location.lon,location.address&movie_id=" +
        this.state.movieSelected.id +
        "&time_from=" +
        this.state.timeFrom.startOf("day").format() +
        "&time_to=" +
        this.state.timeTo.endOf("day").format() +
        locationFilter,
      {
        headers: headers
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.showtimes.length === 0) {
          this.props.setStatus("error","Sorry, no results matched your search.");
          return;
        }
        const cinemas = _.keyBy(responseJson.cinemas, "id");
        this.props.setResultsPage("showtimes")
        this.props.setResults({
          showtimes: responseJson.showtimes,
          cinemas,
          movie: this.state.movieSelected.title,
          location: this.getLocationFilterName(),
          timeFrom: this.state.timeFrom.format("DD/MM"),
          timeTo: this.state.timeTo.format("DD/MM")
        });
        this.props.setStatus("","");
      });
  };
  handleDistanceChange = value => {
    this.setState({ distance: value });
    this.props.setResults({});
    track("distance_radius", {distance: value})
  };

  getMovie = _.debounce(() => {
    const headers = new Headers();
    headers.append("x-api-key", "c87bfbb769147aa04b3390a81dd07e5d");
    fetch(
      "https://api.internationalshowtimes.com/v4/movies?lang=en&search_query=" +
        this.state.movie +
        "&search_field=title",
      {
        headers: headers
      }
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ movieResults: responseJson.movies || [] });
      });
  }, 500);

  handleMovieChange = value => {
    this.setState({ movie: value });
    this.getMovie();
  };

  selectMovie = (movie, selected) => {
    if ((!selected && this.state.movieSelected) || !movie) {
      return;
    }
    this.setState({
      movieSelected: movie,
      movie: movie.title,
      movieResults: []
    });
    track("search_movie",{movie_name: movie.title});
    track("search_film_id",{film_id: movie.id});
    this.props.setResults({});
  };

  getLocation = _.debounce(() => {
    fetch(
      "https://maps.googleapis.com/maps/api/geocode/json?address=" +
        this.state.location +
        "&key=AIzaSyBxneIqyI3u-9mLOTTor7xrIDNUxP_6A5Y"
    )
      .then(response => response.json())
      .then(responseJson => {
        this.setState({ locationResults: responseJson.results || [] });
      });
  }, 500);

  handleLocationChange = value => {
    this.setState({ location: value });
    this.getLocation();
  };

  selectLocation = (location, selected) => {
    if ((!selected && this.state.locationSelected) || !location) {
      return;
    }
    this.setState({
      locationSelected: location,
      location: location.formatted_address,
      locationResults: []
    });
    this.props.setResults({});
    track("location_search",{location_name: location.formatted_address})
  };

  getCountry = _.debounce(() => {
    fetch("http://api.countrylayer.com/v2/name/" + this.state.country + "?access_key=aaa9b3348e4b8dcb0a727f0b13cf0bc5")
      .then(response => response.json())
      .then(responseJson => {
        if (responseJson.status && responseJson.status !== "200") {
          this.setState({ countryResults: [] });
          return;
        }
        this.setState({ countryResults: responseJson || [] });
      });
  }, 500);
  handleCountryChange = value => {
    this.setState({ country: value });
    this.getCountry();
  };

  addCountry = country => {
    this.setState(({ countryCodes }) => ({
      countryCodes: [...countryCodes, country],
      country: "",
      countryResults: []
    }));
    this.props.setResults({});
    track("location_search",{location_name: country.name})
  };
  changeLocationFilter = filter => {
    this.setState({
      locationFilter: filter,
      locationSelected: "",
      location: "",
      locationResults: [],
      countryCodes: [],
      country: "",
      countryResults: [],
      cinemaId: 0
    });
    this.props.setResults({});
    track("location_filter",{option_location_filter: filter})
  };

  getLocationFilterOptions = () => {
    switch (this.state.locationFilter) {
      case "location":
        return (
          <LocationInput
            tabIndex={1}
            focus={this.state.focus === 1}
            value={this.state.location}
            onChange={this.handleLocationChange}
            selectLocation={this.selectLocation}
            locations={this.state.locationResults}
            distance={this.state.distance}
            handleDistanceChange={this.handleDistanceChange}
            isGruvi={this.state.isGruvi}
          />
        );
      case "cinema":
        return (
          <div className="location-filter menu--tab">
            <div className="menu--header">Filter by cinema ids</div>
            <div className="input-container">
              <input
                tabIndex={2}
                type="text"
                value={this.state.cinemaId}
                onChange={e => this.handleChange("cinemaId", e.target.value)}
              />
            </div>
          </div>
        );
      case "country":
        return (
          <CountryInput
            tabIndex={2}
            value={this.state.country}
            onChange={this.handleCountryChange}
            addCountry={this.addCountry}
            countries={this.state.countryResults}
            countryCodes={this.state.countryCodes}
            onDelete={(index) => this.setState(({countryCodes}) => {countryCodes.splice(index, 1);return { countryCodes }})}
          />
        );
      default:
        return (
          <div className="location-filter menu--tab">
          </div>
        );
    }
  };

  handleDateFromChange = value => {
    if (!value) {
      this.setState({ timeFrom: moment(), timeTo: moment().add(7, "days") });
      return;
    }
    const from = value.clone();
    const to = value.add(7, "days");
    this.setState({ timeFrom: from, timeTo: to });
    this.props.setResults({});
    track("date_interaction",{date_start: from.startOf("day").format("DD/MM/YYYY"), date_end:to.endOf("day").format("DD/MM/YYYY")})
  };

  handleDateToChange = value => {
    this.setState({ timeTo: value });
    this.props.setResults({});
    track("date_interaction",{date_end:value.endOf("day").format("DD/MM/YYYY")})
  };

  handleChange = (param, value) => {
    this.setState({ [param]: value });
  };


  componentDidMount() {
    this.setState({ focus: 0 });
  }

  render() {
    return (
      <div className="showtimes-search">
        <div className="menu--section">
          <div className="menu--header">Enter the name of your film</div>
          <MovieInput
            tabIndex={1}
            value={this.state.movie}
            onChange={this.handleMovieChange}
            selectMovie={this.selectMovie}
            movies={this.state.movieResults}
          />
        </div>
        <div className="menu--section">
          {this.props.isGruvi ? <div className="menu--header">Location filter type</div> : <div></div>}
          {this.props.isGruvi ? <SelectTabs
            classes={["flex-row"]}
            selected={this.state.locationFilter}
            options={["location", "country", "cinema"]}
            onValueChange={this.changeLocationFilter}
          /> : <div></div>}
          {this.getLocationFilterOptions()}
        </div>

        {this.props.isGruvi ? <div className="date-pickers menu--tab">
          <div className="date-picker">
            <div className="menu--header">Date Start</div>
            <DatePicker
              tabIndex={3}
              selected={this.state.timeFrom}
              onChange={v => this.handleDateFromChange(v)}
            />
          </div>
          <div className="date-picker">
            <div className="menu--header">Date End</div>
            <DatePicker
              tabIndex={4}
              selected={this.state.timeTo}
              onChange={v => this.handleDateToChange(v)}
            />
          </div>
        </div> : <div className="menu--tab">Results are shown for a period of the next 7 days</div>}
        <div className="menu--tab flex-row justify-center menu--go">
          <Button tabIndex={5} blue onClicked={this.update}>go &gt;</Button>
        </div>
      </div>
    );
  }
}

export default ShowtimesSearch;



// WEBPACK FOOTER //
// ./src/components/ShowtimesSearch.js